import * as $ from "jquery";
import {tns} from 'tiny-slider/src/tiny-slider';

document.addEventListener("DOMContentLoaded", function() {
  $(".card__images-container").each(function() {
    const sight_id = $(this).data('sight_id');
    let slider = tns({
      container: $(`#images-slider-${sight_id}`)[0],
      loop: false,
      items: 1,
      nav: false,
      center: false,
      rewind: true,
      autoHeight: false,
      touch: true,
      mouseDrag: false,
      lazyload: true,
      controlsContainer: `#images-controls-${sight_id}`,
      preventScrollOnTouch: 'auto'
    });
  });
});
